import { Button, Row, Col, Divider } from "antd";

const TipoPromo = ({ esPromo }: { esPromo: string }) => {
  let billeteate = esPromo.includes("B") ? 1 : 0;
  let golpe = esPromo.includes("G") ? 1 : 0;
  let medicacion = esPromo.includes("M") ? 1 : 0;

  return (
    <>
      <Divider orientation='left' style={{ margin: "2px", fontSize: "10px", fontWeight: "bold" }}>
        Tipo de Promo
      </Divider>
      <Row gutter={2} style={{ marginBottom: 15 }} align='middle' justify='space-between'>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid teal",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: medicacion === 1 ? "teal" : "white",
              color: medicacion === 1 ? "white" : "Black",
              boxShadow: "0 0 4px teal",
            }}
          >
            Medicación
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid rebeccapurple",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: golpe === 1 ? "rebeccapurple" : "white",
              color: golpe === 1 ? "white" : "Black",
              boxShadow: "0 0 4px rebeccapurple",
            }}
          >
            Golpe Bajo
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid darkred",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: billeteate === 1 ? "darkred" : "white",
              color: billeteate === 1 ? "white" : "Black",
              boxShadow: "0 0 4px darkred",
            }}
          >
            Billetéate/Ru
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid orange",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: medicacion === 1 ? "orange" : "white",
              color: medicacion === 1 ? "white" : "Black",
              boxShadow: "0 0 4px orange",
            }}
          >
            Boom del Ahorro
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid dodgerblue",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: golpe === 1 ? "dodgerblue" : "white",
              color: golpe === 1 ? "white" : "Black",
              boxShadow: "0 0 4px dodgerblue",
            }}
          >
            Mega Ofertas
          </Button>
        </Col>
        <Col span={4}>
          <Button
            type='default'
            style={{
              border: "2px solid deeppink",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: billeteate === 1 ? "deeppink" : "white",
              color: billeteate === 1 ? "white" : "Black",
              boxShadow: "0 0 4px deeppink",
            }}
          >
            Dermocare
          </Button>
        </Col>
      </Row>

      {/* <Row gutter={2} style={{ marginBottom: 10 }} align='middle' justify='center'>
        <Col span={8}>
          <Button
            type='default'
            style={{
              border: "2px solid orange",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: medicacion === 1 ? "orange" : "white",
              color: medicacion === 1 ? "white" : "Black",
              boxShadow: "0 0 4px orange",
            }}
          >
            Boom del Ahorro
          </Button>
        </Col>
        <Col span={8}>
          <Button
            type='default'
            style={{
              border: "2px solid dodgerblue",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: golpe === 1 ? "dodgerblue" : "white",
              color: golpe === 1 ? "white" : "Black",
              boxShadow: "0 0 4px dodgerblue",
            }}
          >
            Mega Ofertas
          </Button>
        </Col>
        <Col span={8}>
          <Button
            type='default'
            style={{
              border: "2px solid deeppink",
              fontSize: "10px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              justifyContent: " center",
              width: 100,
              height: 25,
              backgroundColor: billeteate === 1 ? "deeppink" : "white",
              color: billeteate === 1 ? "white" : "Black",
              boxShadow: "0 0 4px deeppink",
            }}
          >
            Dermocare
          </Button>
        </Col>
      </Row> */}
    </>
  );
};

export default TipoPromo;

/**golpe bajo/diA DE BEBE---- DIAS  */
